import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '新征程上，努力向前跑——来自华溪村的报道';
const baseUrl = '20220414NLXQP';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/home`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'home',
      name: `${baseUrl}-home`,
      component: () => import('./pages/Home.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'hxc',
      name: `${baseUrl}-rule`,
      component: () => import('./pages/NewsHxc.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'ybh',
      name: `${baseUrl}-rule`,
      component: () => import('./pages/NewsYbh.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'lmz',
      name: `${baseUrl}-rule`,
      component: () => import('./pages/NewsLmz.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
